const cities = [
  { name: "Weston", zips: "33326, 33327, 33331, 33332" },
  { name: "Sunrise", zips: "33313, 33322, 33323, 33351" },
  { name: "Plantation", zips: "33313, 33317, 33322, 33324, 33325" },
  { name: "Davie", zips: "33314, 33317, 33324, 33328, 33330, 33331" },
  { name: "Cooper City", zips: "33328, 33330" },
  { name: "Southwest Ranches", zips: "33330, 33331, 33332" },
  { name: "Pembroke Pines", zips: "33023, 33024, 33025, 33026, 33027, 33028, 33029, 33082, 33084" },
  { name: "Miramar", zips: "33023, 33025, 33027, 33029" },
];

export const landmarks = [
  { name: "Fort Lauderdale-Hollywood Intl (FLL)", distance: "~22 miles", icon: "ri-flight-takeoff-line", desc: "Closest airport — east via I-595 or I-75, direct flights to Bogota, Medellin, Sao Paulo, Caribbean", url: "https://www.broward.org/airport/", schemaType: "Airport" },
  { name: "Miami International Airport (MIA)", distance: "~35 miles", icon: "ri-flight-takeoff-line", desc: "Primary U.S. gateway to Latin America — south via I-75 and Florida's Turnpike", url: "https://www.miami-airport.com/", schemaType: "Airport" },
  { name: "I-75", distance: "Adjacent", icon: "ri-road-map-line", desc: "Primary north-south interstate at Weston's eastern edge — direct access to FLL and MIA", url: "https://en.wikipedia.org/wiki/Interstate_75_in_Florida", schemaType: "CivicStructure" },
  { name: "Weston Town Center", distance: "Downtown", icon: "ri-store-2-line", desc: "Walkable village-style shopping district with boutiques, fine dining, and community events", url: "https://www.westontowncenter.com/", schemaType: "TouristAttraction" },
  { name: "Bonaventure Golf & Country Club", distance: "~2 miles", icon: "ri-trophy-line", desc: "Premier golf and country club — championship course and social amenities", url: "https://www.clubcorp.com/Clubs/Bonaventure-Golf-Club", schemaType: "TouristAttraction" },
  { name: "Sawgrass Mills", distance: "~8 miles", icon: "ri-store-2-line", desc: "Largest outlet mall in the U.S. — 350+ stores, draws international shoppers", url: "https://www.simon.com/mall/sawgrass-mills", schemaType: "TouristAttraction" },
  { name: "Everglades Wildlife Management Area", distance: "~5 miles", icon: "ri-landscape-line", desc: "Protected wetlands bordering Weston — airboat tours, wildlife viewing, nature photography", url: "https://myfwc.com/recreation/", schemaType: "TouristAttraction" },
  { name: "Port Everglades", distance: "~25 miles", icon: "ri-ship-line", desc: "World's 3rd-busiest cruise port — 20-min drive, Royal Caribbean, Carnival, Celebrity year-round", url: "https://www.porteverglades.net/", schemaType: "TouristAttraction" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function WestonLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] pt-12 md:pt-14 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Weston &amp; Western Broward County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Weston, Sunrise, Plantation, Davie, or anywhere in western Broward County, Fast Passport Center makes expedited passport processing simple — no drive to Miami, no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Weston is one of Florida&apos;s most distinctive master-planned communities — a suburban enclave in western Broward County that was meticulously designed around quality of life, green space, and family-centered living. Developed beginning in the mid-1990s, Weston has grown into a community of roughly 70,000 residents who enjoy some of the highest-rated public schools in Florida, an exceptionally low crime rate, and a quality of life that consistently earns national recognition. The city is divided into meticulously landscaped neighborhoods — Weston Hills, Savanna, The Ridges, Bonaventure, and The Landings among them — each with its own character while maintaining the cohesive feel of a single, well-planned community.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Weston Town Center serves as the community&apos;s commercial and social heart, offering boutique shopping, casual and fine dining, and community gathering spaces in a walkable, village-style setting. The Bonaventure Golf &amp; Country Club and Weston Hills Country Club provide world-class golf and country club amenities for residents who value recreation and social connection. The city&apos;s extensive trail system, parks, and nature preserves — including the nearby Everglades Wildlife Management Area — create an unusual combination of suburban comfort and natural Florida wilderness.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What truly distinguishes Weston, however, is its remarkable demographic profile. The city has one of the largest concentrations of Latin American immigrants and first-generation Americans in the United States — particularly Venezuelan, Colombian, Brazilian, and Argentine communities. Weston has been called &ldquo;Little Venezuela&rdquo; by some observers due to the significant Venezuelan-American population that has settled here, drawn by the excellent schools, safe neighborhoods, and proximity to Miami and Fort Lauderdale. Spanish is spoken as comfortably as English in Weston supermarkets, restaurants, and business offices. Portuguese echoes through Brazilian bakeries and cultural centers. This Latin American character fundamentally shapes the travel patterns of Weston residents.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            For Weston families, international travel is not an occasional luxury — it is a regular part of life. Trips to Colombia to visit grandparents in Bogota or Medellin. Summer vacations in Brazil to reconnect with extended family in Sao Paulo or Rio de Janeiro. Emergency flights to Caracas or Buenos Aires when family needs arise. Business travel to Mexico City, Santiago, or Panama City for professionals working in international trade, finance, or logistics. And Caribbean cruises from nearby Port Everglades — a 20-minute drive — for families seeking a different kind of getaway.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Weston&apos;s location is ideal for international travelers. Fort Lauderdale-Hollywood International Airport (FLL) is approximately 20 minutes east via I-595 or I-75, offering direct service to Bogota, Medellin, Caracas, Sao Paulo, Rio de Janeiro, Buenos Aires, Panama City, and virtually every Caribbean destination. Miami International Airport (MIA) — the primary U.S. gateway to Latin America — is roughly 35 minutes south via I-75 and the Turnpike, providing even more flight options to Central and South America. Port Everglades in Fort Lauderdale is one of the busiest cruise ports in the world and sits just 20 minutes from Weston — making Caribbean cruises an effortless weekend or week-long escape for local families.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for hundreds of Weston and Broward County travelers. We understand that a Colombian mother discovering her child&apos;s passport expired three weeks before a Medellin family reunion faces the same urgency as a Brazilian business executive with a Monday meeting in Sao Paulo. Our courier-based expedited service means you start online from your Weston home, ship overnight, and your passport arrives within days — no matter which Latin American capital, Caribbean island, or European city is waiting.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex flex-col xl:flex-row gap-6">
                <div className="flex-1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Weston — approximately 35 miles north via I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Broward County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location near Weston, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

                {/* Map */}
                <div className="xl:w-[340px] flex-shrink-0">
                  <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '260px' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=401+W+Atlantic+Ave+%23351,+Delray+Beach,+FL+33444&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Fast Passport Center Delray Beach Office Location"
                      aria-label="Google Map showing Fast Passport Center Delray Beach office at 401 W Atlantic Ave Suite 351"
                    />
                  </div>
                  <p className="text-white/40 text-xs mt-2 text-center">
                    401 W Atlantic Ave #351, Delray Beach, FL 33444
                  </p>
                </div>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Broward County — start online, ship overnight, and we handle the rest. No need to drive to Miami.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Fort Lauderdale", href: "/fort-lauderdale" },
                  { name: "Miami", href: "/miami" },
                  { name: "Boca Raton", href: "/boca-raton" },
                  { name: "Delray Beach", href: "/delray-beach" },
                  { name: "West Palm Beach", href: "/west-palm-beach" },
                  { name: "Naples", href: "/naples" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Nearby Landmarks & Airports */}
            <div className="mt-6">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                  <i className="ri-landscape-line text-[#1A365D] text-xs"></i>
                </div>
                <h3 className="font-semibold text-[#1A365D] text-sm uppercase tracking-wide">Nearby Landmarks &amp; Airports</h3>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {landmarks.map((item) => (
                  <span
                    key={item.name}
                    className="inline-flex items-center gap-1.5 bg-[#F7F8FA] border border-gray-200/80 rounded-full px-3 py-1.5 hover:border-[#F6C344] transition-colors cursor-default whitespace-nowrap"
                    title={item.desc}
                  >
                    <i className={`${item.icon} text-[#1A365D] text-[10px]`}></i>
                    <span className="text-[#1A365D] font-medium text-[11px]">{item.name}</span>
                    <span className="text-[#F6C344] font-semibold text-[10px]">{item.distance}</span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}